const regex = function () {
	const strategy = {
		phone: function(value) { // 香港手机
			return /^[1][3-8]\d{9}$|^([1|2|3|4|5|6|7|8|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/.test(value)
    },
    email: function(value) {
      return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
    },
    tel: function(value) {
      return /^(2[1-9]|3[1,4-7,9])\d{6}$/.test(value) // 香港座机正则
    },
    AE: function(value) { // AE行用卡
      return /^(34|37)\d{13}$/.test(value);
    },
    MASTER: function(value)  { // MASTER行用卡
      if(/^(51|52|53|54|55)[0-9]{14}$/.test(value)) return true; // 通过
      if(!/^\d{16}$/.test(value)) return false;
      let number = (value +'').substring(0,6)*1;
      if( number >= 222100 && number <= 272099) return true;
      return /^(51|52|53|54|55)[0-9]{14}$/.test(value);
    },
    VISA: function(value) { // VIAS行用卡
      return /^[4][0-9]{12}$|^[4][0-9]{15}|^[4][0-9]{18}/.test(value);
    },
    reg: function(value, reg) {

    }
	}
	
	return function(type, value, reg) {
		return strategy[type] && strategy[type](value, reg)
	}
	
}()
export {
  regex
}